import React from 'react';
import { Upload, Cloud, HardDrive } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface DropZoneProps {
  isDragging: boolean;
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onFileInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onOneDriveSelect: () => void;
}

export const DropZone = ({
  isDragging,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileInput,
  onOneDriveSelect,
}: DropZoneProps) => {
  return (
    <>
      <Upload
        className={cn(
          "w-12 h-12 text-gray-400 transition-transform duration-300",
          isDragging && "scale-110 text-primary"
        )}
      />
      <div className="text-center space-y-4">
        <p className="text-lg font-medium text-gray-700">
          Drop your file here
        </p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          <Button
            variant="outline"
            className="gap-2"
            onClick={() => document.getElementById('file-input')?.click()}
          >
            <HardDrive className="w-4 h-4" />
            Select from Device
          </Button>
          <Button
            variant="outline"
            className="gap-2"
            onClick={onOneDriveSelect}
          >
            <Cloud className="w-4 h-4" />
            Select from OneDrive
          </Button>
        </div>
        <input
          id="file-input"
          type="file"
          className="hidden"
          onChange={onFileInput}
        />
        <p className="text-sm text-gray-500">
          Supports all file types
        </p>
      </div>
    </>
  );
};